const env = process.env.REACT_APP_NODE_ENV;
const isCraDevServer = process.env.NODE_ENV === 'development';

let apiUrl = process.env.REACT_APP_API_URL_DEV;
let aiApiUrl = process.env.REACT_APP_AI_API_URL_DEV;
let stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
let webUrl = process.env.REACT_APP_WEB_URL_DEV;
let partnerDashboardUrl = process.env.REACT_APP_DASHBOARD_URL_DEV;

if (env === 'test') {
  apiUrl = process.env.REACT_APP_API_URL_TEST;
  aiApiUrl = process.env.REACT_APP_AI_API_URL_TEST;
  webUrl = process.env.REACT_APP_WEB_URL_TEST;
  partnerDashboardUrl = process.env.REACT_APP_DASHBOARD_URL_TEST;
} else if (env === 'prod' && !isCraDevServer) {
  apiUrl = process.env.REACT_APP_API_URL_PROD;
  aiApiUrl = process.env.REACT_APP_AI_API_URL_PROD;
  stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_PROD;
  webUrl = process.env.REACT_APP_WEB_URL_PROD;
  partnerDashboardUrl = process.env.REACT_APP_DASHBOARD_URL_PROD;
}

const config = {
  env,
  apiUrl,
  webUrl,
  stripePublishableKey,
  aiApiUrl,
  partnerDashboardUrl
}

export default config;
